<template>
  <div class="start-sale h-100 p-3">
    <div class="initial-page h-100 bg-white">
      <div class="form-placeholder">
        <b-form @submit.prevent="onStartSaleClick">
          <b-form-group>
            <b-input-group>
              <b-form-input :state="formState" size="lg" v-model="saleNo" :placeholder="$t('Sale')"/>
            </b-input-group>
            <b-form-invalid-feedback :state="formState" style="max-width:250px">
              {{ errorMessage }}
            </b-form-invalid-feedback>
            <submit-button size="lg" class="w-100 mt-2" @click.prevent="onStartSaleClick"
                           :text="$t('Start Sale')"/>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import SubmitButton from "../../core/components/common/SubmitButton";
  import LiveBidsService from "./LiveBidsService";

  export default {
    name: "StartSale",
    components: {SubmitButton},
    data() {
      return {
        saleNo: '',
        errorMessage: null
      }
    },
    computed: {
      formState() {
        return this.errorMessage ? false : null
      }
    },
    methods: {
      async onStartSaleClick() {
        this.errorMessage = null;
        if (!this.saleNo) {
          this.errorMessage = this.$i18n.t('Sale is required');
          return
        }
        let response = await LiveBidsService.saleExists(this.saleNo);
        if (!response.success) {
          this.errorMessage = !response.body.sale_no ? this.$i18n.t('Sale not found') : response.body.sale_no[0];
        } else {
          if (response.body.type === 'timed') {
            this.errorMessage = this.$i18n.t('This auction has timed auction status and is not possible to open under auction console');
          } else {
            this.$router.push({name: 'liveBids', params: {saleNo: this.saleNo}})
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables.scss";

  .start-sale {

    .initial-page {
      height: 30em;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-around;
      align-items: center;
      align-content: stretch;
    }
  }

</style>
